import React from "react";
import ContactPage from "../components/contactPage";

const Contact = () => {
    return (
        <ContactPage />
    )
}

export default Contact;